import type { RadarBubble } from "@/services/api/teacher";
import { radarCardKind } from "./talkRadarBubble";
import { formatDay, useRadarStatusLabel } from "./talkRadarReadFormat";

type ClosedCard = {
  id: string;
  kind: "own" | "incoming";
  title: string;
  status: string;
  date: string | null;
  meta: string;
};

function cardsFromBubbles(bubbles: RadarBubble[]): ClosedCard[] {
  const cards = new Map<string, ClosedCard>();
  for (const bubble of bubbles) {
    const ids =
      bubble.request_ids && bubble.request_ids.length > 0
        ? bubble.request_ids
        : bubble.request_id
          ? [bubble.request_id]
          : [];
    const kind = radarCardKind(bubble.bubble_type);
    for (const id of ids) {
      const key = `${kind}:${id}`;
      if (cards.has(key)) continue;
      cards.set(key, {
        id,
        kind,
        title:
          kind === "incoming"
            ? bubble.requester_name || formatDay(bubble.lesson_date) || "Anfrage"
            : formatDay(bubble.lesson_date) || bubble.subject_name || "Anfrage",
        status: bubble.status || "",
        date: bubble.lesson_date,
        meta: bubble.subject_name || "",
      });
    }
  }
  return [...cards.values()];
}

export function TalkTeacherDeck({
  bubbles,
  onOpen,
}: {
  bubbles: RadarBubble[];
  onOpen: (
    id: string,
    kind: "own" | "incoming",
    meta?: { status?: string | null; date?: string | null }
  ) => void;
}) {
  const statusLabel = useRadarStatusLabel();
  const cards = cardsFromBubbles(bubbles);

  return (
    <div className="talk-teacher-stage">
      <p className="talk-deck-title">Karten</p>
      <ul className="talk-radar-list">
        {cards.map((card) => (
          <li key={`${card.kind}-${card.id}`}>
            <button
              type="button"
              className="talk-radar-card"
              aria-expanded={false}
              onClick={() =>
                onOpen(card.id, card.kind, { status: card.status, date: card.date })
              }
            >
              <span className="talk-radar-card-top">
                <span>{card.title}</span>
                <span className="talk-pill">{statusLabel(card.status)}</span>
              </span>
              {card.meta ? <span className="talk-radar-card-title">{card.meta}</span> : null}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
